<!--店铺管理-->
<template>
  <div class="edit-area">
    <el-form ref="registerRef"  :model="detailParam" :rules="rules" label-width="140px">
      <el-form-item  label="账号名:"  prop="name">
        <el-input style="width: 300px" v-model="detailParam.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item  label="账号:"  prop="loginAccount">
        <el-input style="width: 300px" v-model="detailParam.loginAccount" placeholder=""></el-input>
      </el-form-item>
      <div v-if="createType == 2">
        <el-form-item  label="手机号:"  prop="phone">
          <el-input style="width: 300px" v-model="detailParam.phone" onkeyup="value=value.replace(/[^\d]/g,'')">></el-input>
        </el-form-item>
        <el-form-item  label="验证码:"  prop="vccCode">
          <el-input style="width: 300px" v-model="detailParam.vccCode"></el-input>
        </el-form-item>
      </div>
      <el-form-item  label="登录密码:"  prop="loginPasswd">
        <el-input style="width: 300px" v-model="detailParam.loginPasswd"></el-input>
      </el-form-item>
      <el-form-item  label="确认密码:" >
        <el-input style="width: 300px" v-model="detailParam.confirmPasswd"></el-input>
      </el-form-item>
      <el-form-item  label="备注:" >
        <el-input
          type="textarea"
          placeholder=""
          v-model="detailParam.remark"
          maxlength="30"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1" >
      <el-button  @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="handleOK('registerRef')">确认</el-button>
    </div>
  </div>
</template>
<style>

</style>

<script>
  import {createNewStoreAdmin} from '@/api/superAdmin'
  import globaldata from "../../../utils/globaldata";
  export default {
    name: 'StoreAdminDetail',
    props: {
      title: {
        msg: ''
      },
      createType: 0,   //1店铺创建  2超级管理员创建
      detailParam :{
        name:'',    //管理员姓名
        phone :''  , //管理员手机号
        loginAccount : '' , //登录账号
        loginPasswd : '' , //登录密码
        confirmPasswd : '' , //确认密码
        vccCode : '' , //短信验证码
        createAdminId :'', //创建者
        validDate :'', //到期时间
        shopFrontId :'', //店铺id
        remark : '' //备注
      },
    },
    data() {
      return {
        //发送短信
        timerSendCodeTip :'发送短信',
        rules:{
          name:[{required:true,message:"请输入账号名",trigger:"blur"}],
          loginAccount:[{required:true,message:"请输入账号",trigger:"blur"}],
          phone:[{required:true,message:"请输入手机号",trigger:"blur"}],
          vccCode:[{required:true,message:"请输入验证码",trigger:"blur"}],
          loginPasswd:[{required:true,message:"请输入密码",trigger:"blur"}],

        },
      }
    },
    mounted() {

    },
    methods: {
      handleOK(registerRef){

        this.$refs[registerRef].validate((valid) => {
          if (valid) {
            this.onCreateStoreAdmin();
          } else {
            return false
          }
        });
      },
      handleCancel(){
        this.$emit('onBtnCancel');
      },

      /**
       * 检测创建的参数
       */
      checkCreateParam(){

      },

      //创建店铺管理员账号
      onCreateStoreAdmin(){
        console.log("onCreateStoreAdmin")
        this.$emit('onStoreAdmin',this.detailParam);

      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/superadmin/components/StoreAdminDetail.vue